/* -------------------------------------------------------------------------
 * Sayuri signature · lantern-glow  (Tokyo Nights)
 * -------------------------------------------------------------------------
 * Port of `LanternGlow` in the design file (line ~1236). Warm glowing
 * orbs floating up slowly — radial gradient filled with accent-soft at
 * center fading to accent at edge, soft box-shadow bloom, gentle
 * brightness flicker.
 *
 * Scent character: "Whisky in a small glass, leather, the city under
 * neon." Warm + nocturnal + intimate.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('lantern-glow', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 10 : 6;
      var accent = ctx.accent;
      var accentSoft = ctx.accentSoft;
      var rand = ctx.seed('lantern-glow'.charCodeAt(0) * 131 + 12 * 7919);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var left = rand() * 100;
        var size = 30 + rand() * 40;      // 30–70px
        var dur = 22 + rand() * 14;       // 22–36s
        var delay = -rand() * 26;
        var riseVariant = i % 3;
        // Design uses i%9 to vary flicker duration slightly; preserve exactly.
        var flickerSeconds = '2.' + (i % 9) + 's';

        var p = document.createElement('div');
        p.className = 'sayuri-lantern';
        p.style.position = 'absolute';
        p.style.left = left + 'vw';
        p.style.bottom = '-80px';
        p.style.width = size + 'px';
        p.style.height = size + 'px';
        p.style.borderRadius = '50%';
        p.style.background =
          'radial-gradient(circle, ' + accentSoft + 'cc 0%, ' +
          accent + '55 40%, transparent 70%)';
        p.style.boxShadow = '0 0 ' + size + 'px ' + accent + '77';
        p.style.filter = 'blur(2px)';
        p.style.animation =
          'lan-rise-' + riseVariant + ' ' + dur + 's ease-in-out ' + delay + 's infinite, ' +
          'lan-flicker ' + flickerSeconds + ' ease-in-out infinite';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes lan-rise-0 { 0%{opacity:0;transform:translate(0,0);} 15%{opacity:1;} 100%{opacity:0;transform:translate(40px,-120vh);} }',
      '@keyframes lan-rise-1 { 0%{opacity:0;transform:translate(0,0);} 15%{opacity:1;} 100%{opacity:0;transform:translate(-30px,-120vh);} }',
      '@keyframes lan-rise-2 { 0%{opacity:0;transform:translate(0,0);} 15%{opacity:1;} 100%{opacity:0;transform:translate(10px,-120vh);} }',
      '@keyframes lan-flicker { 0%,100%{filter:blur(2px) brightness(1);} 50%{filter:blur(2px) brightness(1.3);} }'
    ].join('')
  });
})();
